import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Exchange } from '../../../../types/exchange'
import { Typography } from '@material-ui/core'
import { SavingAccount } from '../../../../types/savingAccount'

const useStyles = makeStyles(() => ({
  root: {
    margin: '2rem 0',
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
    margin: '1rem 0',
  },
  factsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr ',
    gridTemplateRows: '1fr 1fr ',
    columnGap: '1rem',
    rowGap: '1rem',
    '& > div': {},
  },
  fact: {},
  factTitle: {
    fontSize: '14px',
    color: '#7D7787',
    margin: '.5rem 0',
    fontWeight: 500,
  },
  factValue: {
    fontSize: '14px',
    margin: '.5rem 0',
    fontWeight: 500,
  },
}))

interface props {
  savingAccount: SavingAccount
}

export default function KeyFacts({ savingAccount }: props): JSX.Element {
  const classes = useStyles({})

  const { minimum_deposit, maximum_deposit, countries, payout, kyc } = savingAccount
  return (
    <div className={classes.root}>
      <div>
        <Typography className={classes.title} variant="body2">
          Key Facts
        </Typography>
        <div className={classes.factsContainer}>
          <div className={classes.fact}>
            <Typography variant="body2" className={classes.factTitle}>
              Minimum Deposit
            </Typography>
            <Typography variant="body2" className={classes.factValue}>
              {minimum_deposit}
            </Typography>
          </div>

          <div className={classes.fact}>
            <Typography variant="body2" className={classes.factTitle}>
              Maximum Deposit
            </Typography>
            <Typography variant="body2" className={classes.factValue}>
              {maximum_deposit}
            </Typography>
          </div>

          <div className={classes.fact}>
            <Typography variant="body2" className={classes.factTitle}>
              Countries
            </Typography>
            <Typography variant="body2" className={classes.factValue}>
              {countries}
            </Typography>
          </div>

          {/* <div className={classes.fact}>
            <Typography variant="body2" className={classes.factTitle}>
              Payment Methods
            </Typography>
            <Typography variant="body2" className={classes.factValue}>
              Paypal, Bank Transfer, Credit Card, BTC
            </Typography>
          </div>
          <div className={classes.fact}>
            <Typography variant="body2" className={classes.factTitle}>
              Taker fee
            </Typography>
            <Typography variant="body2" className={classes.factValue}>
              0.24%
            </Typography>
          </div>
          <div className={classes.fact}>
            <Typography variant="body2" className={classes.factTitle}>
              Hacked before?
            </Typography>
            <Typography variant="body2" className={classes.factValue}>
              Yes (2017, 2019)
            </Typography>
          </div>
          <div className={classes.fact}>
            <Typography variant="body2" className={classes.factTitle}>
              Protection
            </Typography>
            <Typography variant="body2" className={classes.factValue}>
              Two Factor Authentication
            </Typography>
          </div> */}
        </div>
      </div>
    </div>
  )
}
